import { Component, OnInit } from '@angular/core';
import { AnnouncementService } from '../../Services/announcement.service';

@Component({
  selector: 'app-announcement-show',
  template: require('./announcement-show.component.html'),
  styles: [require('./announcement-show.component.css')]
})
export class AnnouncementShowComponent implements OnInit {

  message: string= '';
  constructor( private announcementService: AnnouncementService) { }


  ngOnInit() {
    this.checkAnnouncement(); 
    setInterval(
      ()=> {
        this.checkAnnouncement(); 
      },30000); 
    }

  checkAnnouncement(){
    this.announcementService.getAnnouncement().subscribe(x => {
      this.message = x.value;
      // console.log("getting announcement");
      // console.log(x)
      // console.log(this.message.length);
    })
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/announcement-show/announcement-show.component.ts